<template>
  <div class="edition-table">
    <b-row>
      <b-col cols="11">
        <table>
          <thead>
            <th class="edition-table__medium">
              Quartos
            </th>

            <th class="edition-table__large">
              Acréscimo ou desconto
              <InfoTooltip
                text="Se os valores configurados para esta acomodação serão  serão acrescidos os descontados do valor da tarifa base."
                :tooltipMinWidth="200"
              />
            </th>

            <th class="edition-table__large">
              Tipo de Valor
              <InfoTooltip
                text="Se os valores para acréscimo ou desconto, em relação a tarifa base representam um valor monerário absoluto ou percentual."
                :tooltipMinWidth="206"
              />
            </th>

            <th class="edition-table__small">
              Valor
              <InfoTooltip
                text="Valor a ser acrescido ou descontado, pode ser percentual ou absoluto."
                :tooltipMinWidth="159"
              />
            </th>
          </thead>
          <tbody>
            <!-- LINHA -->
            <tr
              v-for="(item, i) in boardData"
              :key="`item-${item.codigoQuarto || i}`"
            >
              <!-- TIPO DE USUÁRIO -->
              <td class="td__padd">{{ item.nome }}</td>

              <!-- TIPO DE VARIAÇÃO -->
              <td class="td__padd">
                <PmwFormSelect
                  v-model="item.selectedVariation"
                  :options="differentialsOptions"
                  label=" "
                  placeholder="Selecione a variação"
                  class="edition-table--select"
                  @change="selectValue('selectedVariation', i)"
                />
              </td>

              <!-- TIPO DE VALOR -->
              <td class="td__padd">
                <PmwFormSelect
                  v-model="item.selectedValueType"
                  :options="valueTypeOptions"
                  label=""
                  placeholder="Selecione o tipo do valor"
                  class="edition-table--select"
                  @change="selectValue('selectedValueType', i)"
                />
              </td>

              <!-- VALOR -->
              <td class="td__padd">
                <PmwFormInput
                  v-if="item.selectedValueType?.value === 1"
                  v-model="item.valorAdicional"
                  type="number"
                  label=""
                  placeholder="0"
                  size="small"
                  sufix="%"
                  class="form--input"
                />

                <!-- INPUT DE PREÇO -->
                <PmwFormCurrencyInput
                  v-if="
                    item.selectedValueType?.value === 2 ||
                      !item.selectedValueType?.value
                  "
                  v-model="item.valorAdicional"
                  :options="{ precision: 2 }"
                  size="small"
                  label=""
                  placeholder="00,00"
                  prefix="R$"
                  type="number"
                  class="edition-table__input"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>

      <b-col class="remove-col" cols="1">
        <button class="remove-col--btn" @click="$emit('closeInputs', $event)">
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/** ======================================================= */
/** Componente da tabela de visualização de edição de diferenciais por usuário */
/** ======================================================= */
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'

export default {
  name: 'AccomodationsValuesInputs',
  components: {
    PmwFormSelect,
    PmwFormCurrencyInput,
    InfoTooltip,
    PmwFormInput
  },

  props: {
    boardData: {
      type: Array
    }
  },

  data() {
    return {
      differentialsOptions: [
        { text: 'Acréscimo', value: 1 },
        { text: 'Desconto', value: 2 }
      ],

      valueTypeOptions: [
        { text: 'Percentual', value: 1 },
        { text: 'Absoluto', value: 2 }
      ]
    }
  },

  created() {
    this.boardData.forEach((item) => {
      if (typeof item.tipoValor === 'number') {
        item.selectedValueType = this.valueTypeOptions.find(
          (opcao) => opcao.value === item.tipoValor
        )
      }

      if (typeof item.tipoDiferencial === 'number') {
        item.selectedVariation = this.differentialsOptions.find(
          (opcao) => opcao.value === item.tipoDiferencial
        )
      }
    })
  },

  methods: {
    selectValue(variable, index) {
      switch (variable) {
        case 'selectedVariation':
          this.$set(this.boardData, index, {
            ...this.boardData[index],
            tipoDiferencial: this.boardData[index].selectedVariation.value
          })
          break

        case 'selectedValueType':
          this.$set(this.boardData, index, {
            ...this.boardData[index],
            tipoValor: this.boardData[index].selectedValueType.value
          })
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$cell-padding: 17px 7px 15px 15px;
$cell-inputs-padding: 25px 15px;

.form {
  &--input {
    width: 100px;
    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight('weight-medium');
      }
      .form-field--label-wrapper {
        line-height: 21px;
        margin-bottom: 3px;
      }
      .pmw-input {
        background: $white;
      }
      .pmw-input--clear {
        z-index: 0;
      }
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-input--field {
        background: $pmw-white;

        &:focus {
          border-color: $pmw-blue;
        }
      }

      .pmw-input__disabled {
        input {
          background: pmw-colors('grey-20');
          color: $pmw-gray-darker;
        }
      }

      .pmw-custom-tooltip {
        line-height: 18px;
      }
    }
  }
}

::v-deep {
  .pmw-form-field--label {
    display: none;
  }
}

.edition-table {
  max-width: 1236px;

  .remove-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    &--btn {
      @include reset-button();

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }

  &--select {
    max-width: 210px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button {
        padding: 0 2px;
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &__input {
    width: 100px;
  }

  &__medium {
    width: 160px;
    min-width: 150px;
  }

  &__large {
    width: 208px;
    min-width: 208px;
  }

  &__small {
    width: 115px;
    min-width: 115px;
  }

  table {
    th {
      padding: $cell-padding;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      font-weight: font-weight('weight-medium');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }
    }

    th {
      font-weight: font-weight('weight-medium');
    }

    .td {
      padding: 0;
      min-width: 1px;

      &__padd {
        padding: $cell-inputs-padding;
        ::v-deep {
          .input-checkbox {
            margin: 0px auto !important;
            display: table;
          }
        }
      }
    }

    .rest-td {
      .td {
        &:first-child {
          border-right: 1px solid $gray-border;
        }

        &:last-child {
          ::v-deep {
            .content-wrapper {
              padding: {
                left: 10px;
                right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
